/**
 * @description javascript related to the data-table
 * handles hiding/showing rows, formatting and sorting.
 */

/**
 * @function init
 * @description Kick off this modules functions
*/
const init = () => {
  bindEvents();
}

/**
 * @function bindEvents
 * @description Bind events for this module
*/
const bindEvents = ()=> {
  toggleRows();
  formatTableData();
  sortTable();
}

/**
 * @description Getting all the data 
*/
const allData = document.querySelectorAll('[data-state]');

/**
 * @function formatTableData
 * @description Format data for table
*/
const formatTableData = () => {
  const formatter = new Intl.NumberFormat( 'en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });

  // (State - National average)
  const nationalPercent = Number(JSON.parse(document.querySelector('[data-location-type="national"]').getAttribute('data-location-data')).percent_spend);

  for (let i = 0; i < allData.length; i++) {
    const el = allData[i];
    const parsedData = JSON.parse(el.dataset.state);
    const statePercent = Number(JSON.parse(el.dataset.state).percent_spend);
    const percentDiff = (((statePercent - nationalPercent)) * 100).toFixed( 2 ) + "%";

    el.querySelector('.ins-annual-report-avg_annual_cost').innerHTML = formatter.format(Number(parsedData.avg_annual_cost));
    el.querySelector('.ins-annual-report-percent_spend').innerHTML = percentDiff; 
  };

}
 
/**
 * @function sortTable
 * @description sort table based on sorting parameter
*/
const sortTable = () => {
  document.querySelectorAll('[data-sort-table]').forEach( (sortBtn) => {

    const sortType = sortBtn.dataset.sortTable; // assign the column header by which we are sorting 
    const tableBody = document.getElementById('ins-annual-report-section-table__body') // data being passed to each row in the body
    const tableRows = document.querySelectorAll('.ins-annual-report-section-table__rows'); //each row and class
    let prevFilter = "";
    let orderAsc;

    // Toggles the order in dec or asc 
    const toggleOrder = () => {
      if (sortType ===  prevFilter) {
        orderAsc = !orderAsc; 
      } else {
        orderAsc = true;
      }
    };

    sortBtn.addEventListener('click', () => {
      toggleOrder();
      const filterRows = Array.prototype.slice.call(tableRows).sort((rowOne, rowTwo) => {
        const rowOneData = JSON.parse(rowOne.dataset.state);
        const rowTwoData = JSON.parse(rowTwo.dataset.state);
        let valueOne = (rowOneData[sortType]);
        let valueTwo = (rowTwoData[sortType]);
        
         // convert the last three collumns of table data into integers
        if(sortType !== 'location' && sortType !== "percent_spend"){
          valueOne = parseInt(valueOne);
          valueTwo = parseInt(valueTwo);
        } else if (sortType === "percent_spend"){
          valueOne = parseFloat(valueOne);
          valueTwo = parseFloat(valueTwo);
        }
        

        if (orderAsc === true) {
          if(valueOne > valueTwo){
          return 1;
          } else if (valueOne < valueTwo){
            return -1;
          } else {
            return 0;
          }
        } else {
          if(valueOne > valueTwo){
            return -1;
          } else if (valueOne < valueTwo){
            return 1;
          } else {
            return 0;
          }
        };
      });
      filterRows.forEach((filterRow) => {
        tableBody.appendChild(filterRow)
      });
      document.querySelectorAll("[data-sort-table] [data-testid]").forEach((sortArrow)=> sortArrow.classList.remove('sort-active'));
      if(orderAsc) {
        document.querySelector(`[data-sort-table=${sortType}] [data-testid='up-sort-arrow']`).classList.add('sort-active');
      } else {
        document.querySelector(`[data-sort-table=${sortType}] [data-testid='down-sort-arrow']`).classList.add('sort-active');
      }
    });
    
    prevFilter = sortType;
    orderAsc = !orderAsc;
  });
};

/**
 * @function toggleRows
 * @description toggle hidden rows
 */
const toggleRows = () => {
  const btnToggle = document.querySelector("[data-toggle]"); 
  const tableId = btnToggle.dataset.toggle;
  let btnLabel = false;
  
  btnToggle.addEventListener('click', () => {
    document.querySelector(tableId).classList.toggle('ins-annual-report-section-table__expanded');

    //Changes the label of the btn used to expand the rows
    if (btnLabel) {
      document.querySelector('.table-expand-btn').innerHTML = "Show all rows";
      //Brings the top of the table back into view when hidding rows
      document.getElementById("top-of-the-table").scrollIntoView();
    }else {
      document.querySelector('.table-expand-btn').innerHTML = "Hide rows";
    }

    btnLabel = !btnLabel
  });
};

export default init;